import * as React from 'react';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DynamicEnrollAnalysisDetails = ({
  selectedEnrollment,
  shouldDisplayEnrollmentWarning
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.DYNAMIC_ENROLL_jsx",
      elements: {
        ObjectNameLabel,
        ListNameLabel,
        b: 'b'
      },
      options: {
        portalId: selectedEnrollment.portalId,
        objectTypeId: selectedEnrollment.objectTypeId,
        objectId: selectedEnrollment.objectId,
        showId: getIsInternal()
      }
    }), shouldDisplayEnrollmentWarning && /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.help.dynamicEnrollTooltip"
      })
    })]
  });
};
export default DynamicEnrollAnalysisDetails;